module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_yoso_location-32cab4465b2850ebb3a3f5d476e82c8f.webp";